import * as React from 'react';
import clsx from 'clsx';
import debounce from 'lodash/debounce';
import shallowequal from 'shallowequal';
import { withTranslator } from '@gandi/translate';
import { Base, Text } from '../../Base';
import InputPassword from '../InputPassword';
import Label from '../Label';
import PasswordMeterHelp from './PasswordMeterHelp';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "PasswordMeter-root_3iXP6",
  "wrapper": "PasswordMeter-wrapper_2iqce",
  "strength": "PasswordMeter-strength_J4hdp",
  "input": "PasswordMeter-input_3Zu4i"
};
function getStrength(props, state) {
  if (state.value === '') {
    return null;
  }
  switch (props.score) {
    case 0:
    case 1:
      return {
        label: props.scoreLabels ? props.scoreLabels[0] : props.translator.__('Weak')
      };
    case 2:
      return {
        label: props.scoreLabels ? props.scoreLabels[1] : props.translator.__('So-so')
      };
    case 3:
      return {
        label: props.scoreLabels ? props.scoreLabels[2] : props.translator.__('Good')
      };
    case 4:
      return {
        label: props.scoreLabels ? props.scoreLabels[3] : props.translator.__('Great!')
      };
    default:
      return null;
  }
}
class PasswordMeter extends React.Component {
  static defaultProps = {
    id: 'password',
    debounceTimeout: 300
  };
  state = (() => ({
    value: this.props.value || ''
  }))();
  UNSAFE_componentWillMount() {
    this.register();
  }
  UNSAFE_componentWillReceiveProps({
    inputs,
    value,
    debounceTimeout
  }) {
    if (typeof value === 'string' && this.state.value !== value) {
      this.setState({
        value
      });
    }
    if (debounceTimeout !== this.props.debounceTimeout) {
      this.register();
    }
    if (!shallowequal(inputs, this.props.inputs)) {
      this.handleCheck();
    }
  }
  componentWillUnmount() {
    this.cancel();
  }
  register = () => {
    this.debounced = debounce(this.handleCheck, this.props.debounceTimeout);
  };
  cancel() {
    if (this.debounced) this.debounced.cancel();
  }
  handleChange = evt => {
    this.setState({
      value: evt.target.value
    }, () => {
      this.debounced();
    });
    if (this.props.handleChange) {
      this.props.handleChange(evt);
    }
  };
  handleCheck = () => {
    if (this.props.handleCheck) {
      this.props.handleCheck(this.state.value);
    }
  };
  handleKeyDown = evt => {
    if (evt.key === 'Enter') {
      this.handleCheck();
    }
    if (this.props.handleKeyDown) {
      this.props.handleKeyDown(evt);
    }
  };
  render() {
    const {
      translator,
      id,
      name,
      labelText,
      value,
      defaultValue,
      score,
      inputs,
      warning,
      suggestions,
      scoreLabels,
      debounceTimeout,
      block,
      required,
      autoComplete,
      className,
      handleCheck,
      handleChange,
      handleKeyDown,
      handleFocus,
      handleBlur,
      ...extraProps
    } = this.props;
    const strength = getStrength(this.props, this.state);
    return /*#__PURE__*/_jsxs(Base, {
      ...extraProps,
      className: clsx(styles.root, className),
      "data-score": this.state.value ? score : null,
      children: [/*#__PURE__*/_jsxs(Base, {
        flex: block,
        flexInline: !block,
        flexCol: true,
        children: [/*#__PURE__*/_jsxs(Base, {
          flex: true,
          flexJustifyBetween: true,
          children: [/*#__PURE__*/_jsx(Label, {
            target: id,
            required: required,
            children: labelText || translator.__('Password')
          }), strength && /*#__PURE__*/_jsx(Text, {
            weight: "semibold",
            className: styles.strength,
            children: strength.label
          })]
        }), /*#__PURE__*/_jsx(Base, {
          className: styles.wrapper,
          children: /*#__PURE__*/_jsx(InputPassword, {
            id: id,
            name: name,
            value: this.state.value,
            defaultValue: defaultValue,
            handleChange: this.handleChange,
            handleKeyDown: this.handleKeyDown,
            handleFocus: handleFocus,
            handleBlur: handleBlur,
            block: block,
            classes: {
              input: styles.input
            },
            autoComplete: autoComplete
          })
        })]
      }), /*#__PURE__*/_jsx(PasswordMeterHelp, {
        warning: warning,
        suggestions: suggestions
      })]
    });
  }
}
export { PasswordMeter };
export default withTranslator({
  propsNamespace: 'translator'
})(PasswordMeter);